// extracted by mini-css-extract-plugin
module.exports = {"messagesTableText":"messagesTableText--Exmw8"};